// dayjs
import 'dayjs/locale/it';
import 'dayjs/locale/en';
import dayjs from "dayjs";
import merge from 'lodash/merge';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

// core (MUI)
import {
  itIT as itITCore,
  enUS as enUSCore,
} from '@mui/material/locale';
// data grid (MUI)
import {
  itIT as itITDataGrid,
  enUS as enUSDataGrid,
} from '@mui/x-data-grid';
// date pickers (MUI)
import {
  itIT as itITDate,
  enUS as enUSDate,
} from '@mui/x-date-pickers/locales';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(updateLocale);
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

// dayjs.tz.setDefault('Europe/Rome');

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------
// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Italian',
    value: 'it',
    // Override: MUI x-date-pickers itIT usa "Cancellare" per il tasto annulla → "Annulla".
    systemValue: merge(itITDate, itITDataGrid, itITCore, {
      components: {
        MuiLocalizationProvider: {
          defaultProps: {localeText: {cancelButtonLabel: 'Annulla'}},
        },
      },
    }),
    adapterLocale: 'it',
    icon: 'flagpack:it',
    numberFormat: {
      code: 'it-IT',
      currency: 'EUR',
    },
  },
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: 'en',
    icon: 'flagpack:gb-ukm',
    numberFormat: {
      code: 'en-US',
      currency: 'USD',
    },
  }

];

export const defaultLang = allLangs[0]; // Italian

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
